import './FanRowSkeleton.sass';

import { FC } from 'react';

export interface FanRowSkeletonProps {
  count?: number;
}

export const FanRowSkeleton: FC<FanRowSkeletonProps> = ({ count = 5 }) => (
  <div className="FanRowSkeleton">
    {Array.from({ length: count }, (_, i) => (
      <div className="FanRowSkeleton__row" key={i}>
        <div className="FanRowSkeleton__rank sk-shimmer" />
        <div className="FanRowSkeleton__avatar sk-shimmer" />
        <div className="FanRowSkeleton__cont">
          <div className="FanRowSkeleton__line sk-shimmer" />
          <div className="FanRowSkeleton__line FanRowSkeleton__line--short sk-shimmer" />
        </div>
        <div className="FanRowSkeleton__value sk-shimmer" />
      </div>
    ))}
  </div>
);
